import { defineStore } from 'pinia'
import { updateStoreState, deleteStoreState, sortObjects } from '../helpers/stateUtils'
import { useAlertStore, useUnitStore } from './'
import Vue from 'vue'
import i18n from '../plugins/i18n'
import { isNil } from 'ramda'
import {
  BEAM_API,
} from '../constants'

export const useUnitCalendarFeedStore = defineStore({
  id: 'unit_calendar_feed',
  state: () => ({
    feeds: [],
  }),
  getters: {
    findById: (state) => (id) => state.feeds.find(find => find.id === id),
    findByIds: (state) => (ids) => sortObjects(state.feeds.filter(find => ids.includes(find.id)), 'channel.name'),
  },
  actions: {
    httpCreateUnitCalendarFeed ({ calendarFeed, unit }) {
      const unitStore = useUnitStore()
      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.post(`/unit/${unit.id}/calendar_feed`, calendarFeed)
        .then((response) => {
          updateStoreState(this.feeds, response.data)

          // add the relation to the unit
          unit.calendarFeeds.push(response.data.id)
          unit.ready = true

          updateStoreState(unitStore.units, unit)

          alertStore.setAlertSuccess({ message: i18n.t('page-unit-ical-sync.actions.add-feed.toast-success') })
        })
        .catch((err) => {
          let headers = err.response.headers

          if ('x-error-code' in headers) {
            switch (headers['x-error-code']) {
              case 'feed-parse':
                alertStore.setAlertError({ message: i18n.t('page-unit-ical-sync.actions.add-feed.toast-error-parse') })
                break
              case 'feed-http-request':
                alertStore.setAlertError({ message: i18n.t('page-unit-ical-sync.actions.add-feed.toast-error-http') })
                break
            }
          } else {
            alertStore.setAlertError({ message: i18n.t('page-unit-ical-sync.actions.add-feed.toast-error') })
          }

          throw err
        })
    },

    httpUpdateUnitCalendarFeed ({ calendarFeed, args }) {
      if (isNil(args)) args = {}

      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.put(`${BEAM_API}/unit_calendar_feeds/${calendarFeed.id}`, calendarFeed)
        .then((response) => {
          updateStoreState(this.feeds, calendarFeed)

          if (!isNil(args.successMessage)) {
            alertStore.setAlertSuccess({ message: args.successMessage })
          }
          return response
        })
        .catch(() => {
          if (!isNil(args.errorMessage)) {
            alertStore.setAlertError({ message: args.errorMessage })
          }
        })
    },

    httpDeleteUnitCalendarFeed ({ calendarFeed, unit }) {
      const alertStore = useAlertStore()
      const unitStore = useUnitStore()

      return Vue.prototype.$httpEZ.delete(`${BEAM_API}/unit_calendar_feeds/${calendarFeed.id}`)
        .then(() => {
          deleteStoreState(this.feeds, calendarFeed.id)

          // remove the relation from the unit
          unit.calendarFeeds = unit.calendarFeeds.filter(item => item !== calendarFeed.id)
          updateStoreState(unitStore.units, unit)

          alertStore.setAlertSuccess({ message: i18n.t('page-unit-ical-sync.actions.delete-feed.toast-success') })
        })
        .catch(() => {
          alertStore.setAlertError({ message: i18n.t('page-unit-ical-sync.actions.delete-feed.toast-error') })
        })
    },
  },
})
